import { render, staticRenderFns } from "./PaginatedTables.vue?vue&type=template&id=3aec561c&scoped=true&"
import script from "./PaginatedTables.vue?vue&type=script&lang=js&"
export * from "./PaginatedTables.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedTables.vue?vue&type=style&index=0&id=3aec561c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec561c",
  null
  
)

export default component.exports